import type { ComponentNameAndModule } from '@sitecore-jss/sitecore-jss-angular';

const loadChildren = () =>
  import('./feh-standalone-forms.lazy.module').then(
    (module) => module.FehStandaloneFormsLazyModule
  );

export const fehStandaloneFormsLazyImports: ComponentNameAndModule[] = [
  {
    path: 'GeneralAdviceForm',
    canActivate: [],
    loadChildren,
  },
];
